module.exports = __webpack_public_path__ + "static/icons/icon-ski-lessons-7c53cdf96eddab66edfb1170e1d983b5.svg";